import * as React from "react";
const SvgFiRrDeer = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-deer_svg__a)">
      <path
        fill="#062147"
        d="M23.442 7.067c-.304-.308-1.38-1.355-2.719-2.14A3.99 3.99 0 0 0 22 2a1 1 0 1 0-2 0c0 1.103-.897 2-2 2h-.5A2.503 2.503 0 0 1 15 1.5V1a1 1 0 1 0-2 0v.5c0 .924.28 1.784.76 2.5H12.5A2.503 2.503 0 0 1 10 1.5V1a1 1 0 1 0-2 0v.5C8 3.981 10.02 6 12.5 6h1.308C13.191 6.942 13 7.988 13 8.586V9.5a.5.5 0 0 1-.5.5H6.17c-1.12 0-2.173.44-2.963 1.239-.062.063-2.93 3.071-2.93 3.071a1.001 1.001 0 0 0 1.446 1.38l.35-.367c.118.936.362 1.645.616 2.383.101.294.207.6.31.939v2.354c0 1.654 1.346 3 3 3s3-1.346 3-3v-1h3v1c0 1.654 1.346 3 3 3s3-1.346 3-3v-2.115c.627-.746 2-2.695 2-5.485v-2.007l2.1-.24a2.17 2.17 0 0 0 1.9-2.153c0-.511-.072-1.441-.558-1.933zm-1.58 2.1-2.089.238A2 2 0 0 0 18 11.392v2.007c0 2.669-1.684 4.37-1.697 4.384A1 1 0 0 0 16 18.5V21a1 1 0 0 1-2 0v-2a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v2a1 1 0 0 1-2 0v-2.5q0-.144-.04-.281a24 24 0 0 0-.379-1.162c-.316-.921-.566-1.648-.58-2.863a2.15 2.15 0 0 1 .628-1.548 2.15 2.15 0 0 1 1.54-.645H12.5c1.38 0 2.5-1.122 2.5-2.5v-.914c0-.265.08-2.586 2.867-2.586 1.15 0 2.893 1.221 4.066 2.386.034.129.066.39.066.614 0 .085-.063.158-.138.167z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-deer_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDeer;
